export default "__VITE_ASSET__BsVMx2d3__"